import { isMobile } from "./isMobile";

export const hasDeviceOrientation = async ():Promise<boolean> => {
	if(!isMobile()){ return false; }
	if(window.DeviceOrientationEvent !== undefined && typeof window.DeviceOrientationEvent.requestPermission === "function"){
		try {
			const r = await window.DeviceOrientationEvent.requestPermission();
			return r === "granted";
		}
		catch(err){
			console.error(err);
			return false;
		}
	}
	return true;
}